'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _css2 = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css3 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css4 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _css5 = require('antd/lib/select/style/css');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _currency_input = require('./currency_input');

var _currency_input2 = _interopRequireDefault(_currency_input);

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * 根据商品规格设定商品编码、重量和价格
                                                                                                                                                                                                                   */


var Option = _select2.default.Option;

var keysToOmit = ['code', 'weight', 'price', 'templates'];
var ProductPrice = _react2.default.createClass({
    displayName: 'ProductPrice',
    getInitialState: function getInitialState() {
        return {
            deleted: []
        };
    },
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (JSON.stringify(this.state.deleted) !== JSON.stringify(nextState.deleted)) {
            return true;
        }
        if (JSON.stringify(this.props.addedSpecs) === JSON.stringify(nextProps.addedSpecs)) {
            return false;
        }
        return true;
    },
    onChange: function onChange(index, record, field, event) {
        var value = event.target.value;
        if (field === 'code') {
            if (value.length < 1) {
                _message2.default.error('商品编码不可为空，请修改！');
                event.target.focus();
                event.target.setSelectionRange(0, value.length);
                return;
            }
            var isDuplicate = this.props.prices.filter(function (price, i) {
                return price.code === value && JSON.stringify((0, _utils.omit)(record, keysToOmit)) !== JSON.stringify((0, _utils.omit)(price, keysToOmit));
            }).length >= 1;
            if (isDuplicate) {
                _message2.default.error('商品编码不可重复，请修改！');
                event.target.focus();
                event.target.setSelectionRange(0, value.length);
                return;
            }
        }
        record[field] = value;
        this.props.onChangePrice(index, record);
    },
    onTemplateChange: function onTemplateChange(index, record, value) {
        record.templates = value;
        this.props.onChangePrice(index, record);
    },
    onDel: function onDel(index, record, event) {
        this.setState({
            deleted: this.state.deleted.concat((0, _utils.omit)(record, keysToOmit))
        });
    },
    render: function render() {
        var _this = this;

        var _props = this.props,
            addedSpecs = _props.addedSpecs,
            prices = _props.prices;

        var columns = [{
            title: '商品编码',
            key: 'code',
            render: function render(text, record, index) {
                return _react2.default.createElement(_input2.default, { defaultValue: record.code, style: { width: '6em' }, onBlur: _this.onChange.bind(_this, index, record, 'code') });
            }
        }, {
            title: '重量',
            key: 'weight',
            render: function render(text, record, index) {
                return _react2.default.createElement(_input2.default, { type: 'number', defaultValue: record.weight, style: { 'width': '8em' }, onBlur: _this.onChange.bind(_this, index, record, 'weight') });
            }
        }, {
            title: '价格',
            key: 'price',
            render: function render(text, record, index) {
                return _react2.default.createElement(_currency_input2.default, { defaultValue: record.price, style: { 'width': '8em' }, onBlur: _this.onChange.bind(_this, index, record, 'price') });
            }
        }, {
            title: '模版',
            key: 'templates',
            render: function render(text, record, index) {
                return _react2.default.createElement(
                    _select2.default,
                    {
                        multiple: true,
                        onChange: _this.onTemplateChange.bind(_this, index, record),
                        placeholder: '\u8BF7\u9009\u62E9\u6A21\u7248',
                        style: { minWidth: '12em', maxWidth: '20em' },
                        defaultValue: record.templates || []
                    },
                    _this.props.templates.map(function (x) {
                        return _react2.default.createElement(
                            Option,
                            { key: x.id },
                            x.title
                        );
                    })
                );
            }
        }, {
            title: '操作',
            key: 'action',
            render: function render(text, record, index) {
                return _react2.default.createElement(
                    _button2.default,
                    { onClick: _this.onDel.bind(_this, index, record) },
                    '\u5220\u9664'
                );
            }
        }];

        if (this.props.params && this.props.params.productID !== 'create') {
            columns.push({
                title: '生成二维码',
                key: 'qrcode',
                render: function render(text, record, index) {
                    return _react2.default.createElement(
                        _button2.default,
                        { onClick: function onClick(e) {
                                return _this.props.showModal(index, record);
                            } },
                        '\u751F\u6210'
                    );
                }
            });
        }

        addedSpecs.forEach(function (spec) {
            columns.unshift({
                title: spec.name,
                key: spec.name,
                dataIndex: spec.name
            });
        });

        var data = [];
        if (addedSpecs.length === 1) {
            addedSpecs[0].values.forEach(function (value) {
                var isDeleted = _this.state.deleted.some(function (x) {
                    return JSON.stringify(x) === JSON.stringify(_defineProperty({}, addedSpecs[0].name, value));
                });
                if (isDeleted) return;
                var record = {};
                record[addedSpecs[0].name] = value;
                var targetPrice = prices.find(function (x) {
                    return x[addedSpecs[0].name] == value;
                });
                if (targetPrice) {
                    record.sku_id = targetPrice.sku_id;
                    record.code = targetPrice.code;
                    record.weight = targetPrice.weight;
                    record.price = targetPrice.price;
                    record.templates = targetPrice.templates && targetPrice.templates.map(function (x) {
                        return '' + x;
                    });
                }
                data.push(record);
            });
        } else if (addedSpecs.length === 2) {
            addedSpecs[0].values.forEach(function (value1) {
                addedSpecs[1].values.forEach(function (value2) {
                    var isDeleted = _this.state.deleted.some(function (x) {
                        var _JSON$stringify2;

                        return JSON.stringify(x) === JSON.stringify((_JSON$stringify2 = {}, _defineProperty(_JSON$stringify2, addedSpecs[0].name, value1), _defineProperty(_JSON$stringify2, addedSpecs[1].name, value2), _JSON$stringify2));
                    });
                    if (isDeleted) return;
                    var record = {};
                    record[addedSpecs[0].name] = value1;
                    record[addedSpecs[1].name] = value2;
                    var targetPrice = prices.find(function (x) {
                        return x[addedSpecs[0].name] == value1 && x[addedSpecs[1].name] == value2;
                    });
                    if (targetPrice) {
                        record.sku_id = targetPrice.sku_id;
                        record.code = targetPrice.code;
                        record.weight = targetPrice.weight;
                        record.price = targetPrice.price;
                        record.templates = targetPrice.templates && targetPrice.templates.map(function (x) {
                            return '' + x;
                        });
                    }
                    data.push(record);
                });
            });
        } else if (addedSpecs.length === 3) {
            addedSpecs[0].values.forEach(function (value1) {
                addedSpecs[1].values.forEach(function (value2) {
                    addedSpecs[2].values.forEach(function (value3) {
                        var isDeleted = _this.state.deleted.some(function (x) {
                            var _JSON$stringify3;

                            return JSON.stringify(x) === JSON.stringify((_JSON$stringify3 = {}, _defineProperty(_JSON$stringify3, addedSpecs[0].name, value1), _defineProperty(_JSON$stringify3, addedSpecs[1].name, value2), _defineProperty(_JSON$stringify3, addedSpecs[2].name, value3), _JSON$stringify3));
                        });
                        if (isDeleted) return;
                        var record = {};
                        record[addedSpecs[0].name] = value1;
                        record[addedSpecs[1].name] = value2;
                        record[addedSpecs[2].name] = value3;
                        var targetPrice = prices.find(function (x) {
                            return x[addedSpecs[0].name] == value1 && x[addedSpecs[1].name] == value2 && x[addedSpecs[2].name] == value3;
                        });
                        if (targetPrice) {
                            record.sku_id = targetPrice.sku_id;
                            record.code = targetPrice.code;
                            record.weight = targetPrice.weight;
                            record.price = targetPrice.price;
                            record.templates = targetPrice.templates && targetPrice.templates.map(function (x) {
                                return '' + x;
                            });
                        }
                        data.push(record);
                    });
                });
            });
        }
        var tableConfig = {
            columns: columns,
            dataSource: data,
            showHeader: true,
            pagination: false,
            locale: { emptyText: '请先添加规格并输入相应规格值' },
            bordered: true,
            rowKey: function rowKey(record) {
                var rowKey = '';
                for (var key in record) {
                    rowKey += record[key];
                }
                return rowKey;
            }
        };
        return _react2.default.createElement(_table2.default, tableConfig);
    }
});

exports.default = ProductPrice;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/product_price.js
// module id = 1492
// module chunks = 0